import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "./modal.react";
import Select from "react-select";
import Dropzone from "react-dropzone";
import Isvg from "react-inlinesvg";
import Media from "./media.react";
import Pagination from "./pagination/pagination.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class MediaModal extends Component {
  static propTypes = {
    closeModalAction: PropTypes.func,
    mainAction: PropTypes.func,
    actions: PropTypes.object,
    notificationSystem: PropTypes.object,
    mediaCategoriesSearch: PropTypes.object,
    medias: PropTypes.object,
    mediaCategories: PropTypes.object,
    selectedMediaItem: PropTypes.object,
    apiHost: PropTypes.string
  };

  componentDidMount() {
    const {
      actions,
      mediaCategories,
      mediaCategoriesSearch,
      notificationSystem,
      meta
    } = this.props;

    actions.resetSelectedMediaItems();

    if (mediaCategories.first()) {
      if (!mediaCategoriesSearch.get("uid")) {
        actions.setSearchField(
          "mediaCategories",
          "uid",
          mediaCategories.first().get("uid")
        );
        actions
          .getMediaCategoryMedias(mediaCategories.first().get("uid"), meta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      } else {
        actions
          .getMediaCategoryMedias(mediaCategoriesSearch.get("uid"), meta)
          .then(({ error, payload }) => {
            if (error) {
              addNotificationsForInvalidFields(payload, notificationSystem);
            }
          });
      }
    }
  }

  closeModal = () => {
    const { closeModalAction } = this.props;
    closeModalAction();
  };

  mainAction = () => {
    const { mainAction } = this.props;
    mainAction();
  };

  onFileSubmit = files => {
    const self = this;
    const {
      actions,
      notificationSystem,
      mediaCategoriesSearch,
      meta
    } = this.props;

    files.forEach(function(file, index) {
      actions.uploadFile(file).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        } else {
          actions
            .createMediaCategoryMedia(
              {
                name: payload.name,
                description: "",
                fileUID: payload.uid
              },
              mediaCategoriesSearch.get("uid")
            )
            .then(({ error, payload }) => {
              if (error) {
                addNotificationsForInvalidFields(payload, notificationSystem);
              } else {
                actions
                  .getMediaCategoryMedias(
                    mediaCategoriesSearch.get("uid"),
                    meta
                  )
                  .then(({ error, payload }) => {
                    if (error) {
                      addNotificationsForInvalidFields(
                        payload,
                        notificationSystem
                      );
                    }
                  });
              }
            });
        }
      });
    });
  };

  onMediaCategorySelect = value => {
    if (value) {
      const { actions, notificationSystem, meta } = this.props;
      actions.setPaginationPage("medias", 0);
      actions.setSearchField("mediaCategories", "uid", value);
      let newMeta = meta.toJS();

      newMeta.currentPage = 0;
      actions
        .getMediaCategoryMedias(value, newMeta)
        .then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
    }
  };

  paginationAction = page => {
    const {
      actions,
      notificationSystem,
      meta,
      mediaCategoriesSearch
    } = this.props;
    actions.setPaginationPage("medias", page);
    let newMeta = meta.toJS();
    newMeta.currentPage = page;
    actions
      .getMediaCategoryMedias(mediaCategoriesSearch.get("uid"), newMeta)
      .then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
  };

  render() {
    const {
      mediasResults,
      medias,
      mediaCategoriesSearch,
      mediaCategories,
      selectedMediaItem,
      actions,
      apiHost,
      meta
    } = this.props;

    const self = this;

    let mediaCategoriesSelectOptions = [];
    mediaCategories.forEach(function(mediaCategory, index) {
      mediaCategoriesSelectOptions.push({
        value: mediaCategory.get("uid"),
        label: mediaCategory.get("name")
      });
    });

    const mediasHTML = mediasResults.map(function(mediaUID, index) {
      if (
        medias.getIn([mediaUID, "mediaCategoryUID"]) ===
        mediaCategoriesSearch.get("uid")
      ) {
        return (
          <Media
            key={index}
            actions={actions}
            media={medias.get(mediaUID)}
            selectedMediaItem={selectedMediaItem}
            apiHost={apiHost}
          />
        );
      }
    });

    return (
      <Modal
        closeModalAction={this.closeModal}
        enterAction={this.mainAction}
        handleKeyDownEvent={true}
      >
        <div className="row middle-xs">
          <h3 className="col-xs-12 col-sm-6">Wybierz media: </h3>
          <div className="col-xs-12 col-sm-6">
            <Select
              name="select-media-category"
              value={mediaCategoriesSearch.get("uid")}
              options={mediaCategoriesSelectOptions}
              onChange={this.onMediaCategorySelect}
              clearable={false}
            />
          </div>

          <div className="col-xs-12 media-item">
            <div className="row">{mediasHTML}</div>
            <Pagination
              numberOfPages={Math.ceil(meta.all / meta.limit)}
              setPageAction={this.paginationAction}
              maxPagesDisplay={5}
              currentPage={meta.currentPage + 1}
            />
          </div>
          <button className="info" onClick={this.mainAction}>
            Wybierz
          </button>
          <button className="info" onClick={this.closeModal}>
            Anuluj
          </button>
        </div>
        <Dropzone
          onDrop={this.onFileSubmit}
          className="dropzone"
          activeClassName="dropzone-active"
        >
          <div>
            <Isvg className="dropzone-icon" src="/assets/img/icon_upload.svg" />
            <p className="dropzone-text">Upuść lub kliknij aby dodać zdjęcia</p>
          </div>
        </Dropzone>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/mediasModal.react.js